export const popularDrinks = [
    {
        "idDrink": "11005",
        "strDrink": "Dry Martini",
        "strDrinkAlternate": null,
        "strTags": "IBA,Classic,Christmas,Alcoholic",
        "strVideo": null,
        "strCategory": "Cocktail",
        "strIBA": "Unforgettables",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Cocktail glass",
        "strInstructions": "Straight: Pour all ingredients into mixing glass with ice cubes. Stir well. Strain in chilled martini cocktail glass. Squeeze oil from lemon peel onto the drink, or garnish with olive.",
        "strInstructionsES": null,
        "strInstructionsDE": null,
        "strInstructionsFR": null,
        "strInstructionsIT": "Dritto: Versare tutti gli ingredienti nel mixing glass con cubetti di ghiaccio. Mescolare bene. Filtrare in una coppetta da cocktail Martini ghiacciata. Spremi l'olio della scorza di limone sulla bevanda o guarnisci con l'oliva.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/6ck9yi1589574317.jpg",
        "strIngredient1": "Gin",
        "strIngredient2": "Dry Vermouth",
        "strIngredient3": "Olive",
        "strIngredient4": null,
        "strIngredient5": null,
        "strIngredient6": null,
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "1 2/3 oz ",
        "strMeasure2": "1/3 oz ",
        "strMeasure3": "1 ",
        "strMeasure4": null,
        "strMeasure5": null,
        "strMeasure6": null,
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": "https://www.thecocktaildb.com/drink/11005",
        "strImageAttribution": "TheCocktailDB.com",
        "strCreativeCommonsConfirmed": "Yes",
        "dateModified": "2017-09-02 12:51:35"
    },
    {
        "idDrink": "11007",
        "strDrink": "Margarita",
        "strDrinkAlternate": null,
        "strTags": "IBA,ContemporaryClassic",
        "strVideo": null,
        "strCategory": "Ordinary Drink",
        "strIBA": "Contemporary Classics",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Cocktail glass",
        "strInstructions": "Rub the rim of the glass with the lime slice to make the salt stick to it. Take care to moisten only the outer rim and sprinkle the salt on it. The salt should present to the lips of the imbiber and never mix into the cocktail. Shake the other ingredients with ice, then carefully pour into the glass.",
        "strInstructionsES": null,
        "strInstructionsDE": "Reiben Sie den Rand des Glases mit der Limettenscheibe, damit das Salz daran haftet. Achten Sie darauf, dass nur der äußere Rand angefeuchtet wird und streuen Sie das Salz darauf. Das Salz sollte sich auf den Lippen des Genießers befinden und niemals in den Cocktail einmischen. Die anderen Zutaten mit Eis schütteln und vorsichtig in das Glas geben.",
        "strInstructionsFR": null,
        "strInstructionsIT": "Strofina il bordo del bicchiere con la fetta di lime per far aderire il sale.\r\nAvere cura di inumidire solo il bordo esterno e cospargere di sale.\r\nIl sale dovrebbe presentarsi alle labbra del bevitore e non mescolarsi mai al cocktail.\r\nShakerare gli altri ingredienti con ghiaccio, quindi versarli delicatamente nel bicchiere.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/5noda61589575158.jpg",
        "strIngredient1": "Tequila",
        "strIngredient2": "Triple sec",
        "strIngredient3": "Lime juice",
        "strIngredient4": "Salt",
        "strIngredient5": null,
        "strIngredient6": null,
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "1 1/2 oz ",
        "strMeasure2": "1/2 oz ",
        "strMeasure3": "1 oz ",
        "strMeasure4": null,
        "strMeasure5": null,
        "strMeasure6": null,
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": "https://commons.wikimedia.org/wiki/File:Klassiche_Margarita.jpg",
        "strImageAttribution": "Cocktailmarler",
        "strCreativeCommonsConfirmed": "Yes",
        "dateModified": "2015-08-18 14:42:59"
    },
    {
        "idDrink": "11000",
        "strDrink": "Mojito",
        "strDrinkAlternate": null,
        "strTags": "IBA,ContemporaryClassic,Alcoholic,USA,Asia,Vegan,Citrus,Brunch,Hangover,Mild",
        "strVideo": null,
        "strCategory": "Cocktail",
        "strIBA": "Contemporary Classics",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Highball glass",
        "strInstructions": "Muddle mint leaves with sugar and lime juice. Add a splash of soda water and fill the glass with cracked ice. Pour the rum and top with soda water. Garnish and serve with straw.",
        "strInstructionsES": null,
        "strInstructionsDE": "Minzblätter mit Zucker und Limettensaft verrühren. Füge einen Spritzer Sodawasser hinzu und fülle das Glas mit gebrochenem Eis. Den Rum eingießen und mit Sodawasser übergießen. Garnieren und mit einem Strohhalm servieren.",
        "strInstructionsFR": null,
        "strInstructionsIT": "Pestare le foglie di menta con lo zucchero e il succo di lime.\r\nAggiungere una spruzzata di acqua di seltz e riempi il bicchiere con ghiaccio tritato.\r\nVersare il rum e riempire con acqua di seltz.\r\nGuarnire con una fetta di lime, servire con una cannuccia.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/metwgh1606770327.jpg",
        "strIngredient1": "Light rum",
        "strIngredient2": "Lime",
        "strIngredient3": "Sugar",
        "strIngredient4": "Mint",
        "strIngredient5": "Soda water",
        "strIngredient6": null,
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "2-3 oz ",
        "strMeasure2": "Juice of 1 ",
        "strMeasure3": "2 tsp ",
        "strMeasure4": "2-4 ",
        "strMeasure5": null,
        "strMeasure6": null,
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": "https://pixabay.com/photos/cocktail-mojito-cocktail-recipe-5096281/",
        "strImageAttribution": "anilaha https://pixabay.com/users/anilaha-16242978/",
        "strCreativeCommonsConfirmed": "Yes",
        "dateModified": "2016-11-04 09:17:09"
    },
    {
        "idDrink": "17196",
        "strDrink": "Cosmopolitan",
        "strDrinkAlternate": null,
        "strTags": "IBA,ContemporaryClassic",
        "strVideo": null,
        "strCategory": "Cocktail",
        "strIBA": "Contemporary Classics",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Cocktail glass",
        "strInstructions": "Add all ingredients into cocktail shaker filled with ice. Shake well and double strain into large cocktail glass. Garnish with lime wheel.",
        "strInstructionsES": null,
        "strInstructionsDE": "Alle Zutaten in den mit Eis gefüllten Cocktailshaker geben. Gut schütteln und doppelt in ein großes Cocktailglas abseihen. Mit Limettenrad garnieren.",
        "strInstructionsFR": null,
        "strInstructionsIT": "Aggiungi tutti gli ingredienti in uno shaker pieno di ghiaccio.\r\nShakerare bene e filtrare due volte in una grande coppetta da cocktail.\r\nGuarnire con una fetta di lime.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/kpsajh1504368362.jpg",
        "strIngredient1": "Absolut Citron",
        "strIngredient2": "Lime juice",
        "strIngredient3": "Cointreau",
        "strIngredient4": "Cranberry juice",
        "strIngredient5": null,
        "strIngredient6": null,
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "1 1/4 oz ",
        "strMeasure2": "1/4 oz ",
        "strMeasure3": "1/4 oz ",
        "strMeasure4": "1/4 cup ",
        "strMeasure5": null,
        "strMeasure6": null,
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": null,
        "strImageAttribution": null,
        "strCreativeCommonsConfirmed": "No",
        "dateModified": "2017-09-02 17:06:02"
    },
    {
        "idDrink": "17207",
        "strDrink": "Pina Colada",
        "strDrinkAlternate": null,
        "strTags": "IBA,ContemporaryClassic",
        "strVideo": null,
        "strCategory": "Ordinary Drink",
        "strIBA": "Contemporary Classics",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Collins glass",
        "strInstructions": "Mix with crushed ice in blender until smooth. Pour into chilled glass, garnish and serve.",
        "strInstructionsES": null,
        "strInstructionsDE": "Mit zerstoßenem Eis im Mixer mischen, bis es glatt ist. In ein gekühltes Glas geben, garnieren und servieren.",
        "strInstructionsFR": null,
        "strInstructionsIT": "Mescolare con ghiaccio tritato in un frullatore fino a che liscio.\r\nVersare in un bicchiere freddo, guarnire e servire.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/cpf4j51504371346.jpg",
        "strIngredient1": "Light rum",
        "strIngredient2": "Coconut milk",
        "strIngredient3": "Pineapple",
        "strIngredient4": null,
        "strIngredient5": null,
        "strIngredient6": null,
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "3 oz ",
        "strMeasure2": "3 tblsp ",
        "strMeasure3": "3 tblsp ",
        "strMeasure4": null,
        "strMeasure5": null,
        "strMeasure6": null,
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": null,
        "strImageAttribution": null,
        "strCreativeCommonsConfirmed": "No",
        "dateModified": "2017-09-02 17:55:46"
    },
    {
        "idDrink": "12754",
        "strDrink": "Sex on the Beach",
        "strDrinkAlternate": null,
        "strTags": "IBA,ContemporaryClassic",
        "strVideo": null,
        "strCategory": "Ordinary Drink",
        "strIBA": "Contemporary Classics",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Highball glass",
        "strInstructions": "Build all ingredients in a highball glass filled with ice. Garnish with orange slice.",
        "strInstructionsES": null,
        "strInstructionsDE": "Alle Zutaten in einem mit Eis gefüllten Highball-Glas geben. Mit einer Orangenscheibe garnieren.",
        "strInstructionsFR": null,
        "strInstructionsIT": "Metti tutti gli ingredienti in un bicchiere highball pieno di ghiaccio. Guarnire con fetta d'arancia.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/lijtw51551455287.jpg",
        "strIngredient1": "Vodka",
        "strIngredient2": "Peach schnapps",
        "strIngredient3": "Cranberry juice",
        "strIngredient4": "Grapefruit juice",
        "strIngredient5": null,
        "strIngredient6": null,
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "1 oz ",
        "strMeasure2": "3/4 oz ",
        "strMeasure3": null,
        "strMeasure4": null,
        "strMeasure5": null,
        "strMeasure6": null,
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": null,
        "strImageAttribution": null,
        "strCreativeCommonsConfirmed": "No",
        "dateModified": "2016-07-21 10:12:45"
    },
    {
        "idDrink": "11113",
        "strDrink": "Bloody Mary",
        "strDrinkAlternate": null,
        "strTags": "IBA,ContemporaryClassic",
        "strVideo": null,
        "strCategory": "Ordinary Drink",
        "strIBA": "Contemporary Classics",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Old-fashioned glass",
        "strInstructions": "Stirring gently, pour all ingredients into highball glass. Garnish.",
        "strInstructionsES": null,
        "strInstructionsDE": "Unter leichtem Rühren alle Zutaten in ein Highball-Glas geben. Garnieren.",
        "strInstructionsFR": null,
        "strInstructionsIT": "Mescolando delicatamente, versare tutti gli ingredienti nel bicchiere highball.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/t6caa21582485702.jpg",
        "strIngredient1": "Vodka",
        "strIngredient2": "Tomato juice",
        "strIngredient3": "Lemon juice",
        "strIngredient4": "Worcestershire sauce",
        "strIngredient5": "Tabasco sauce",
        "strIngredient6": "Lime",
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "1 1/2 oz ",
        "strMeasure2": "3 oz ",
        "strMeasure3": "1 dash ",
        "strMeasure4": "1/2 tsp ",
        "strMeasure5": "2-3 drops ",
        "strMeasure6": "1 wedge ",
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": "https://www.thecocktaildb.com/drink/11113-Bloody-Mary",
        "strImageAttribution": "TheCocktialDB.com",
        "strCreativeCommonsConfirmed": "Yes",
        "dateModified": "2015-08-18 15:09:14"
    },
    {
        "idDrink": "11288",
        "strDrink": "Cuba Libre",
        "strDrinkAlternate": null,
        "strTags": "IBA,ContemporaryClassic",
        "strVideo": null,
        "strCategory": "Ordinary Drink",
        "strIBA": "Contemporary Classics",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Highball glass",
        "strInstructions": "Build all ingredients in a Collins glass filled with ice. Garnish with lime wedge.",
        "strInstructionsES": null,
        "strInstructionsDE": "Geben Sie alle Zutaten in ein mit Eis gefülltes Collins-Glas. Mit Limettenkeil garnieren.",
        "strInstructionsFR": null,
        "strInstructionsIT": "Mettere tutti gli ingredienti in un bicchiere Collins pieno di ghiaccio. Guarnire con uno spicchio di lime.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/wmkbfj1606853905.jpg",
        "strIngredient1": "Light rum",
        "strIngredient2": "Lime",
        "strIngredient3": "Coca-Cola",
        "strIngredient4": null,
        "strIngredient5": null,
        "strIngredient6": null,
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "2 oz ",
        "strMeasure2": "Juice of 1/2 ",
        "strMeasure3": null,
        "strMeasure4": null,
        "strMeasure5": null,
        "strMeasure6": null,
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": "https://commons.wikimedia.org/wiki/File:Cuba_Libre.jpg",
        "strImageAttribution": "Martin Belam (currybet)",
        "strCreativeCommonsConfirmed": "Yes",
        "dateModified": "2016-09-06 23:41:03"
    },
    {
        "idDrink": "11009",
        "strDrink": "Moscow Mule",
        "strDrinkAlternate": null,
        "strTags": "IBA,ContemporaryClassic",
        "strVideo": null,
        "strCategory": "Punch / Party Drink",
        "strIBA": "Contemporary Classics",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Copper Mug",
        "strInstructions": "Combine vodka and ginger beer in a highball glass filled with ice. Add lime juice. Stir gently. Garnish.",
        "strInstructionsES": null,
        "strInstructionsDE": "Mischen Sie Wodka und Ingwerbier in einem mit Eis gefüllten Highball-Glas. Limettensaft hinzufügen. Vorsichtig umrühren. Garnieren.",
        "strInstructionsFR": null,
        "strInstructionsIT": "Unisci la vodka e la ginger beer in un bicchiere highball pieno di ghiaccio.\r\nAggiungi il succo di lime.\r\nMescola delicatamente.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/3pylqc1504370988.jpg",
        "strIngredient1": "Vodka",
        "strIngredient2": "Lime juice",
        "strIngredient3": "Ginger ale",
        "strIngredient4": null,
        "strIngredient5": null,
        "strIngredient6": null,
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "2 oz ",
        "strMeasure2": "2 oz ",
        "strMeasure3": "8 oz ",
        "strMeasure4": null,
        "strMeasure5": null,
        "strMeasure6": null,
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": "https://commons.wikimedia.org/wiki/File:Moscow_Mule_at_Rye,_San_Francisco.jpg",
        "strImageAttribution": "Will Shenton\r\n",
        "strCreativeCommonsConfirmed": "Yes",
        "dateModified": "2017-09-02 17:49:48"
    },
    {
        "idDrink": "11202",
        "strDrink": "Caipirinha",
        "strDrinkAlternate": null,
        "strTags": "ContemporaryClassic,IBA",
        "strVideo": null,
        "strCategory": "Ordinary Drink",
        "strIBA": "Contemporary Classics",
        "strAlcoholic": "Alcoholic",
        "strGlass": "Old-fashioned glass",
        "strInstructions": "Place lime and sugar into old fashioned glass and muddle (mash the two ingredients together using a muddler or a wooden spoon). Fill the glass with ice and add the Cachaça.",
        "strInstructionsES": null,
        "strInstructionsDE": "Limette und Zucker in ein old-fashioned Glas geben und vermengen (die beiden Zutaten mit einem Mixer oder einem Holzlöffel vermengen). Füllen Sie das Glas mit Eis und geben Sie den Cacha dazu.",
        "strInstructionsFR": null,
        "strInstructionsIT": "Mettere il lime e lo zucchero nel bicchiere vecchio stile e pestare (schiacciare i due ingredienti insieme usando un pestello o un cucchiaio di legno).Riempi il bicchiere di ghiaccio e aggiungi la Cachaça.",
        "strInstructionsZH-HANS": null,
        "strInstructionsZH-HANT": null,
        "strDrinkThumb": "https://www.thecocktaildb.com/images/media/drink/jgvn7p1582484435.jpg",
        "strIngredient1": "Sugar",
        "strIngredient2": "Lime",
        "strIngredient3": "Cachaca",
        "strIngredient4": null,
        "strIngredient5": null,
        "strIngredient6": null,
        "strIngredient7": null,
        "strIngredient8": null,
        "strIngredient9": null,
        "strIngredient10": null,
        "strIngredient11": null,
        "strIngredient12": null,
        "strIngredient13": null,
        "strIngredient14": null,
        "strIngredient15": null,
        "strMeasure1": "2 tsp",
        "strMeasure2": "1 ",
        "strMeasure3": "2 1/2 oz ",
        "strMeasure4": null,
        "strMeasure5": null,
        "strMeasure6": null,
        "strMeasure7": null,
        "strMeasure8": null,
        "strMeasure9": null,
        "strMeasure10": null,
        "strMeasure11": null,
        "strMeasure12": null,
        "strMeasure13": null,
        "strMeasure14": null,
        "strMeasure15": null,
        "strImageSource": "https://www.thecocktaildb.com/drink/11202-Caipirinha",
        "strImageAttribution": "TheCocktailDB.com",
        "strCreativeCommonsConfirmed": "Yes",
        "dateModified": "2016-07-21 09:42:01"
    },


]